export const createGroup = (label: string): HTMLDivElement => {
  const group = document.createElement('div');
  group.className = 'toolbar-group';

  if (label) {
    const labelEl = document.createElement('span');
    labelEl.className = 'toolbar-label';
    labelEl.textContent = label;
    group.appendChild(labelEl);
  }

  return group;
};

export const createActionButton = (options: {
  icon: string;
  title: string;
  onClick: () => void;
  setIcon: (btn: HTMLButtonElement, icon: string) => void;
  className?: string;
  preventPenHover?: boolean;
}): HTMLButtonElement => {
  const btn = document.createElement('button');
  btn.className = options.className ?? 'action-btn';
  options.setIcon(btn, options.icon);
  btn.title = options.title;

  btn.addEventListener('click', (): void => {
    options.onClick();
  });

  if (options.preventPenHover) {
    btn.addEventListener('pointerdown', (e: PointerEvent): void => {
      if (e.pointerType === 'pen' && e.pressure === 0) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  }

  return btn;
};

export const createToggleButton = (options: {
  icon: string;
  title: string;
  onClick: () => void;
  setIcon: (btn: HTMLButtonElement, icon: string) => void;
  className?: string;
}): HTMLButtonElement => {
  const btn = document.createElement('button');
  btn.className = options.className ?? 'action-btn toggle-btn';
  options.setIcon(btn, options.icon);
  btn.title = options.title;
  btn.addEventListener('click', options.onClick);
  return btn;
};

export const createDivider = (className = 'toolbar-divider'): HTMLDivElement => {
  const divider = document.createElement('div');
  divider.className = className;
  return divider;
};

export const setToggleButtonState = (
  button: HTMLButtonElement | null,
  enabled: boolean,
  className = 'active'
): void => {
  button?.classList.toggle(className, enabled);
};
